import React from 'react'
import CountryQuiz from './CountryQuiz';
import { ContextProvider } from './Context';
function App() {
    return (
        <ContextProvider>
            <CountryQuiz/>
        </ContextProvider>
    )
}
export default App